import { Css, Tag, useTestIds } from "@homebound/beam";
import { Card } from "src/components/Card";
import { PlanPackageOverviewV2_ReadyPlanOptionFragment } from "src/routes/libraries/plan-package-v2/components/OverviewTab.generated";
import { count } from "src/utils";

type ElevationsCardProps = { elevations: PlanPackageOverviewV2_ReadyPlanOptionFragment[]; exteriorSchemeCount: number };

export function ElevationsCard({ elevations, exteriorSchemeCount }: ElevationsCardProps) {
  const tid = useTestIds({}, "elevationsCard");

  return (
    <Card xss={Css.p3.$}>
      <h3 css={Css.lg.mb2.$} {...tid.title}>
        {count(elevations, "Elevation")}
      </h3>
      <ul css={Css.listReset.$}>
        {elevations.isEmpty ? (
          <div>No elevations added.</div>
        ) : (
          elevations.map(({ id, code, name, programData }, i) => (
            <li key={id} css={Css.py2.if(i > 0).bt.bcGray200.$} {...tid.elevation}>
              <div css={Css.mdSb.$}>
                {code} - {name}
                {i === 0 && <Tag text="Default" type="info" xss={Css.ml1.mya.$} />}
              </div>
              <div css={Css.df.gap2.sm.gray700.mtPx(4).$}>
                <span>{programData.sellableSqft} sqft</span>
                <span>{count(exteriorSchemeCount, "Exterior Elevation")}</span>
              </div>
            </li>
          ))
        )}
      </ul>
    </Card>
  );
}
